import React from 'react'
import { toast } from 'react-toastify';

const PaymentAccountInfo = ({memberAccountInfo}) => {

  const copyToClipboard = (text) => {
    navigator.clipboard.writeText(text)
      .then(() => {
        toast.success('Successfully copied to clipboard!');
      })
      .catch(err => {
        toast.error('Error copying to clipboard: ', err);
      });
  }

  return (
    <div className="alert border-dashed alert-secondary" role="alert">
        <div className="d-flex align-items-center account-info">
            <div>
                <p className="mb-0">BANK NAME</p>
                <h6>{memberAccountInfo.bank}</h6>
            </div>
        </div>
        <div className="d-flex align-items-center account-info">
            <div>
                <p className="mb-0">ACCOUNT NAME</p>
                <h6>{memberAccountInfo.account_name}</h6>
            </div>
            <div className="ms-auto cursor-pointer" onClick={() => copyToClipboard(memberAccountInfo.account_name)}>
                <i className="bx bx-copy"></i>
            </div>
        </div>
        <div className="d-flex align-items-center account-info">
            <div>
                <p className="mb-0">ACCOUNT NUMBER</p>
                <h6 className="num">{memberAccountInfo.account_number}</h6>
            </div>
            <div className="ms-auto cursor-pointer" onClick={() => copyToClipboard(memberAccountInfo.account_number)}>
                <i className="bx bx-copy"></i>
            </div>
        </div>
    </div>
  )
}

export default PaymentAccountInfo